import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, InjectionToken, ɵɵinject, Inject, Optional, ɵɵdirectiveInject, ElementRef, Renderer2, ɵɵdefineComponent, ɵɵviewQuery, ɵɵqueryRefresh, ɵɵloadQuery, ɵɵlistener, ɵɵresolveWindow, ɵɵelement, ɵɵtext, Component, ViewChild, HostListener, Injector, ɵɵdefineDirective, Directive, ɵɵInheritDefinitionFeature, Input, ɵɵgetCurrentView, ɵɵelementStart, ɵɵrestoreView, ɵɵnextContext, ɵɵelementEnd, EventEmitter, ɵɵstaticViewQuery, ɵɵtemplate, ɵɵadvance, ɵɵclassMap, ɵɵproperty, Output, ɵɵtextInterpolate, ɵɵtextInterpolate1, ɵɵpropertyInterpolate1, ɵɵsanitizeUrl, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵclassProp, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { __awaiter } from 'tslib';
import { BehaviorSubject, of, fromEvent, interval, Subscription, Subject, combineLatest } from 'rxjs';
import { loadAgeGenderModel, loadTinyFaceDetectorModel, loadFaceRecognitionModel, loadFaceLandmarkModel, loadFaceExpressionModel, loadMtcnnModel, loadSsdMobilenetv1Model, detectAllFaces, FaceMatcher, fetchImage, TinyFaceDetectorOptions, resizeResults, FaceDetection, draw } from 'face-api.js';
import { isNullOrUndefined } from 'util';
import swal from 'sweetalert2';
import { HttpService } from '@akeela/properties';
import { NgIf, CommonModule } from '@angular/common';
import { OverlayConfig, Overlay, OverlayModule } from '@angular/cdk/overlay';
import { ComponentPortal, PortalModule } from '@angular/cdk/portal';
import { switchMap, shareReplay, map } from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';

class FacialRecognitionService {
    constructor() { }
}
FacialRecognitionService.ɵfac = function FacialRecognitionService_Factory(t) { return new (t || FacialRecognitionService)(); };
FacialRecognitionService.ɵprov = ɵɵdefineInjectable({ token: FacialRecognitionService, factory: FacialRecognitionService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FacialRecognitionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class WebcamUtil {
    /**
     * Lists available videoInput devices
     * @returns a list of media device info.
     */
    static getAvailableVideoInputs() {
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
            return Promise.reject('enumerateDevices() not supported.');
        }
        return new Promise((resolve, reject) => {
            navigator.mediaDevices.enumerateDevices()
                .then((devices) => {
                resolve(devices.filter((device) => device.kind === 'videoinput'));
            })
                .catch(err => {
                reject(err.message || err);
            });
        });
    }
}

class FaceDetectorRespService {
    constructor() {
        this.responseFaceApi = new BehaviorSubject(null);
    }
}
FaceDetectorRespService.ɵfac = function FaceDetectorRespService_Factory(t) { return new (t || FaceDetectorRespService)(); };
FaceDetectorRespService.ɵprov = ɵɵdefineInjectable({ token: FaceDetectorRespService, factory: FaceDetectorRespService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FaceDetectorRespService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const ModelsUrl = new InjectionToken('ngx-face-api-js.models-url');

const ExpressionsFeatureToken = 'expressions';
const LandmarksFeatureToken = 'landmarks';
const DescriptorsFeatureToken = 'descriptors';
const AgeAndGenderToken = 'ageAndGender';

const SsdMobilenetv1Model = 'SsdMobilenetv1Model';
const MtcnnModel = 'MtcnnModel';
const FaceExpressionModel = 'FaceExpressionModel';
const FaceLandmarkModel = 'FaceLandmarkModel';
const FaceRecognitionModel = 'FaceRecognitionModel';
const TinyFaceDetectorModel = 'TinyFaceDetectorModel';
const AgeAndGenderModel = 'AgeAndGenderModel';

class ModelLoaderService {
    constructor(modelUrl) {
        this.modelUrl = modelUrl;
        this.loadedModels = [];
        this.loadModels = (requires) => {
            const tokens = [];
            requires.map((r) => {
                tokens.push(r);
            });
            return tokens;
        };
    }
    getReqiredModels(tokens) {
        return [TinyFaceDetectorModel].concat(Object.entries({
            [ExpressionsFeatureToken]: [FaceExpressionModel, TinyFaceDetectorModel],
            [LandmarksFeatureToken]: [FaceLandmarkModel, TinyFaceDetectorModel],
            [DescriptorsFeatureToken]: [FaceRecognitionModel, TinyFaceDetectorModel],
            [AgeAndGenderToken]: [AgeAndGenderModel, TinyFaceDetectorModel],
        })
            .map(([key, models]) => tokens.includes(key) ? models : [])
            .reduce((a, b) => a.concat(b))
            .filter((v, i, arr) => arr.indexOf(v) === i));
    }
    mapLoadFunction(model) {
        switch (model) {
            case SsdMobilenetv1Model:
                return loadSsdMobilenetv1Model;
            case MtcnnModel:
                return loadMtcnnModel;
            case FaceExpressionModel:
                return loadFaceExpressionModel;
            case FaceLandmarkModel:
                return loadFaceLandmarkModel;
            case FaceRecognitionModel:
                return loadFaceRecognitionModel;
            case TinyFaceDetectorModel:
                return loadTinyFaceDetectorModel;
            case AgeAndGenderModel:
                return loadAgeGenderModel;
        }
    }
    isLoaded(model) {
        return this.loadedModels.includes(model);
    }
    load(...models) {
        return __awaiter(this, void 0, void 0, function* () {
            const loadTargetModels = models.filter(m => this.isLoaded(m) === false);
            yield Promise.all(loadTargetModels
                .map(m => this.mapLoadFunction(m))
                .map(load => load(this.modelUrl)));
            if (loadTargetModels.length >= 0) {
                this.loadedModels = loadTargetModels.concat(this.loadedModels);
            }
        });
    }
    loadForFeature(tokens) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqiredModels = this.getReqiredModels(tokens);
            yield this.load(...reqiredModels);
        });
    }
}
ModelLoaderService.ɵfac = function ModelLoaderService_Factory(t) { return new (t || ModelLoaderService)(ɵɵinject(ModelsUrl)); };
ModelLoaderService.ɵprov = ɵɵdefineInjectable({ token: ModelLoaderService, factory: ModelLoaderService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ModelLoaderService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ModelsUrl]
            }] }]; }, null); })();

class DetectTask {
    constructor(option) {
        this._tokens = ['expressions', 'descriptors'];
        this.type = option.type;
        this.tokens = option.tokens;
        this.draw = option.draw;
        this.realtime = option.realtime || false;
        this.target = new Promise(resolver => (this.targetResolver = resolver));
    }
    get resolveTarget() {
        return this.targetResolver;
    }
    isMatchPattern(patten, target) {
        return patten.every(item => target.includes(item));
    }
    with(...tokens) {
        this.tokens.push(...tokens);
        return this;
    }
    detect(option) {
        return __awaiter(this, void 0, void 0, function* () {
            let t;
            t = detectAllFaces(yield this.target, option || undefined);
            return t
                .withFaceLandmarks()
                .withFaceExpressions()
                .withFaceDescriptors()
                .run();
        });
    }
}

class FaceCompareService {
    constructor(modelLoaderService) {
        this.modelLoaderService = modelLoaderService;
        // test: compate two images
        this.compare = (base64ImgBase, base64ICompare) => {
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                const a = new DetectTask({
                    type: 'all',
                    tokens: [],
                    draw: false
                });
                const sourceImageResult = yield this.fetchImage(base64ImgBase);
                const faceMatcher = new FaceMatcher(sourceImageResult);
                const targetImageResult = yield this.fetchImage(base64ICompare);
                yield targetImageResult.forEach(fd => {
                    const bestMatch = faceMatcher.findBestMatch(fd.descriptor);
                    resolve(bestMatch.toString());
                });
            }));
        };
        this.fetchImage = (base64Image) => __awaiter(this, void 0, void 0, function* () {
            const img = yield fetchImage(base64Image);
            return yield detectAllFaces(img).withFaceLandmarks().withFaceDescriptors();
        });
    }
}
FaceCompareService.ɵfac = function FaceCompareService_Factory(t) { return new (t || FaceCompareService)(ɵɵinject(ModelLoaderService)); };
FaceCompareService.ɵprov = ɵɵdefineInjectable({ token: FaceCompareService, factory: FaceCompareService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FaceCompareService, [{
        type: Injectable
    }], function () { return [{ type: ModelLoaderService }]; }, null); })();

class CountdownService {
    constructor() {
        this.countdownService = new BehaviorSubject(null);
        this.countdownLimitedService = new BehaviorSubject(null);
        this.interval = null;
        this.intervalLimited = null;
    }
    start() {
        this.interval = this.showDate();
    }
    stop() {
        clearInterval(this.interval);
    }
    showDate() {
        var date = new Date('2020-01-01 00:01');
        // Función para rellenar con ceros
        var padLeft = n => "00".substring(0, "00".length - n.length) + n;
        // Asignar el intervalo a una variable para poder eliminar el intervale cuando llegue al limite
        var interval = setInterval(() => {
            // Asignar el valor de minutos
            var minutes = padLeft(date.getMinutes() + "");
            // Asignqr el valor de segundos
            var seconds = padLeft(date.getSeconds() + "");
            console.log(minutes, seconds);
            // Restarle a la fecha actual 1000 milisegundos
            date = new Date(date.getTime() - 1000);
            // Si llega a 2:45, eliminar el intervalo
            if (minutes == '00' && seconds == '30') {
                clearInterval(interval);
                this.countdownService.next({ status: 'finish', minutes: minutes, seconds: seconds });
            }
            else {
                this.countdownService.next({ status: 'active', minutes: minutes, seconds: seconds });
            }
        }, 1000);
        return interval;
    }
    startLimited() {
        this.intervalLimited = this.showDateLimited();
    }
    stopLimited() {
        clearInterval(this.intervalLimited);
    }
    showDateLimited() {
        var date = new Date('2020-01-01 00:01');
        // Función para rellenar con ceros
        var padLeft = n => "00".substring(0, "00".length - n.length) + n;
        // Asignar el intervalo a una variable para poder eliminar el intervale cuando llegue al limite
        var interval = setInterval(() => {
            // Asignar el valor de minutos
            var minutes = padLeft(date.getMinutes() + "");
            // Asignqr el valor de segundos
            var seconds = padLeft(date.getSeconds() + "");
            console.log(minutes, seconds);
            // Restarle a la fecha actual 1000 milisegundos
            date = new Date(date.getTime() - 1000);
            // Si llega a 2:45, eliminar el intervalo
            if (minutes == '00' && seconds == '00') {
                clearInterval(interval);
                this.countdownLimitedService.next({ status: 'finish', minutes: minutes, seconds: seconds });
            }
            else {
                this.countdownLimitedService.next({ status: 'active', minutes: minutes, seconds: seconds });
            }
        }, 1000);
        return interval;
    }
}
CountdownService.ɵfac = function CountdownService_Factory(t) { return new (t || CountdownService)(); };
CountdownService.ɵprov = ɵɵdefineInjectable({ token: CountdownService, factory: CountdownService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CountdownService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * Container class for a captured webcam image
 * @author basst314, davidshen84
 */
class WebcamImage {
    constructor(imageAsDataUrl, mimeType, imageData) {
        this._mimeType = null;
        this._imageAsBase64 = null;
        this._imageAsDataUrl = null;
        this._imageData = null;
        this._mimeType = mimeType;
        this._imageAsDataUrl = imageAsDataUrl;
        this._imageData = imageData;
    }
    /**
     * Extracts the Base64 data out of the given dataUrl.
     * @param dataUrl the given dataUrl
     * @param mimeType the mimeType of the data
     */
    static getDataFromDataUrl(dataUrl, mimeType) {
        return dataUrl.replace(`data:${mimeType};base64,`, '');
    }
    /**
     * Get the base64 encoded image data
     * @returns base64 data of the image
     */
    get imageAsBase64() {
        return this._imageAsBase64 ? this._imageAsBase64
            : this._imageAsBase64 = WebcamImage.getDataFromDataUrl(this._imageAsDataUrl, this._mimeType);
    }
    /**
     * Get the encoded image as dataUrl
     * @returns the dataUrl of the image
     */
    get imageAsDataUrl() {
        return this._imageAsDataUrl;
    }
    /**
     * Get the ImageData object associated with the canvas' 2d context.
     * @returns the ImageData of the canvas's 2d context.
     */
    get imageData() {
        return this._imageData;
    }
}

const FaceDetectionOptions = new InjectionToken('ngx-face-api-js.face-detection-options');

class FaceDetectorService {
    constructor(modelLoader, option) {
        this.modelLoader = modelLoader;
        this.option = option;
        this.tokens = ['expressions', 'landmarks', 'descriptors'];
    }
    detect(task) {
        if (task.realtime === true) {
            return of(task).pipe(switchMap((t) => __awaiter(this, void 0, void 0, function* () { return yield t.target; })), switchMap(video => fromEvent(video, 'loadeddata')), switchMap(() => this.modelLoader.loadForFeature(this.tokens)), switchMap(() => interval(900)), switchMap(() => task.detect(new TinyFaceDetectorOptions())), shareReplay(1));
        }
        //task.tokens
        return of(task).pipe(switchMap((t) => __awaiter(this, void 0, void 0, function* () { return yield t.target; })), switchMap(image => fromEvent(image, 'load')), switchMap(() => __awaiter(this, void 0, void 0, function* () { return yield this.modelLoader.loadForFeature(this.tokens); })), switchMap(() => task.detect(this.option)), shareReplay(1));
    }
}
FaceDetectorService.ɵfac = function FaceDetectorService_Factory(t) { return new (t || FaceDetectorService)(ɵɵinject(ModelLoaderService), ɵɵinject(FaceDetectionOptions, 8)); };
FaceDetectorService.ɵprov = ɵɵdefineInjectable({ token: FaceDetectorService, factory: FaceDetectorService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FaceDetectorService, [{
        type: Injectable
    }], function () { return [{ type: ModelLoaderService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [FaceDetectionOptions]
            }] }]; }, null); })();

const _c0 = ["canvas"];
class DetectionResultComponent {
    constructor(task, el, renderer, faceDetector, faceDetectorResponse) {
        this.task = task;
        this.el = el;
        this.renderer = renderer;
        this.faceDetector = faceDetector;
        this.faceDetectorResponse = faceDetectorResponse;
        this.subscription = new Subscription();
        this.resize$ = new Subject();
        this.resetCanvas = () => {
            const context = this.canvas.getContext('2d');
            context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        };
    }
    get canvas() {
        return this.canvasEl.nativeElement;
    }
    onResize() {
        this.resize$.next('onResize');
    }
    convertResultToArray(result) {
        if (Array.isArray(result)) {
            return result;
        }
        return [result];
    }
    ngOnInit() {
        //           this.resize$.pipe(startWith('init')),
        this.subscription.add(combineLatest(this.faceDetector.detect(this.task)).pipe(map(([result]) => this.convertResultToArray(result)))
            .subscribe(result => {
            console.log('Recibiendo...');
            this.faceDetectorResponse.responseFaceApi.next(result);
        }));
    }
    ngOnDestroy() {
        this.resetCanvas();
        this.subscription.unsubscribe();
    }
    draw(results) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = yield this.task.target;
            let { width, height } = target;
            if (target instanceof HTMLVideoElement) {
                height = target.videoHeight;
                width = target.videoWidth;
            }
            const detectionsForSize = resizeResults(results.map(result => result instanceof FaceDetection ? result : result.detection), { width, height });
            console.log(width, height);
            this.canvas.width = width;
            this.canvas.height = height;
            this.renderer.setStyle(this.canvas, 'width', `${width}px`);
            this.renderer.setStyle(this.canvas, 'height', `${height}px`);
            if (this.task.tokens.length >= 1) {
                console.log('entra');
                draw.drawDetections(this.canvas, detectionsForSize);
                const resizeResults$1 = resizeResults(results, { width, height });
                if (this.task.tokens.includes('expressions')) {
                    draw.drawFaceExpressions(this.canvas, resizeResults$1.map(({ detection, expressions }) => ({
                        position: detection.box,
                        expressions,
                    })));
                }
                if (this.task.tokens.includes('landmarks')) {
                    draw.drawFaceLandmarks(this.canvas, resizeResults$1.map(({ landmarks }) => landmarks));
                }
                /**
                 * [
                        `${faceapi.round(age, 0)} years`,
                        `${gender} (${faceapi.round(genderProbability)})`,
                      ],
                */
                if (this.task.tokens.includes('ageAndGender')) {
                    resizeResults$1.forEach(result => {
                        const { age, gender, genderProbability } = result;
                        const text = new draw.DrawTextField([
                            `${age} years`,
                            `${gender} (${genderProbability})`,
                        ], result.detection.box.bottomLeft);
                        text.draw(this.canvas);
                    });
                }
            }
            else {
                draw.drawDetections(this.canvas, detectionsForSize);
            }
        });
    }
}
DetectionResultComponent.ɵfac = function DetectionResultComponent_Factory(t) { return new (t || DetectionResultComponent)(ɵɵdirectiveInject(DetectTask), ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(Renderer2), ɵɵdirectiveInject(FaceDetectorService), ɵɵdirectiveInject(FaceDetectorRespService)); };
DetectionResultComponent.ɵcmp = ɵɵdefineComponent({ type: DetectionResultComponent, selectors: [["ng-component"]], viewQuery: function DetectionResultComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.canvasEl = _t.first);
    } }, hostBindings: function DetectionResultComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("resize", function DetectionResultComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵɵresolveWindow);
    } }, decls: 3, vars: 0, consts: [["canvas", ""]], template: function DetectionResultComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "canvas", null, 0);
        ɵɵtext(2, "sssssss\n");
    } }, styles: ["canvas[_ngcontent-%COMP%]{height:100%;width:100%}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DetectionResultComponent, [{
        type: Component,
        args: [{
                templateUrl: './detection-result.component.html',
                styleUrls: ['./detection-result.component.scss'],
            }]
    }], function () { return [{ type: DetectTask }, { type: ElementRef }, { type: Renderer2 }, { type: FaceDetectorService }, { type: FaceDetectorRespService }]; }, { canvasEl: [{
            type: ViewChild,
            args: ['canvas']
        }], onResize: [{
            type: HostListener,
            args: ['window:resize']
        }] }); })();

class AbstractDetectDirective {
    constructor(el, overlay, injector) {
        this.el = el;
        this.overlay = overlay;
        this.injector = injector;
        this.with = [];
        this.draw = true;
    }
    ngOnInit() {
        this.task = new DetectTask({
            type: this.type,
            tokens: this.with,
            draw: this.draw,
            realtime: this.stream,
        });
    }
    get orverlayPositionStrategy() {
        return this.overlay
            .position()
            .flexibleConnectedTo(this.el)
            .withPositions([
            {
                overlayX: 'start',
                overlayY: 'top',
                originX: 'start',
                originY: 'top',
            },
        ])
            .withFlexibleDimensions(false)
            .withLockedPosition(true);
    }
    createOverlay() {
        const scrollStrategy = this.overlay.scrollStrategies.reposition();
        const config = new OverlayConfig({
            positionStrategy: this.orverlayPositionStrategy,
            scrollStrategy,
            hasBackdrop: false,
        });
        return this.overlay.create(config);
    }
    createInjector() {
        return Injector.create({
            parent: this.injector,
            providers: [
                {
                    provide: DetectTask,
                    useValue: this.task,
                },
            ],
        });
    }
    ngAfterViewInit() {
        this.task.resolveTarget(this.el.nativeElement);
        const overlayRef = this.createOverlay();
        const injector = this.createInjector();
        const portal = new ComponentPortal(DetectionResultComponent, undefined, injector);
        overlayRef.attach(portal);
    }
}
AbstractDetectDirective.ɵfac = function AbstractDetectDirective_Factory(t) { return new (t || AbstractDetectDirective)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(Overlay), ɵɵdirectiveInject(Injector)); };
AbstractDetectDirective.ɵdir = ɵɵdefineDirective({ type: AbstractDetectDirective });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AbstractDetectDirective, [{
        type: Directive
    }], function () { return [{ type: ElementRef }, { type: Overlay }, { type: Injector }]; }, null); })();

class DetectAllFacesVideoDirective extends AbstractDetectDirective {
    constructor(el, overlay, injector) {
        super(el, overlay, injector);
        this.with = [];
        this.draw = true;
        this.type = 'all';
        this.stream = true;
    }
}
DetectAllFacesVideoDirective.ɵfac = function DetectAllFacesVideoDirective_Factory(t) { return new (t || DetectAllFacesVideoDirective)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(Overlay), ɵɵdirectiveInject(Injector)); };
DetectAllFacesVideoDirective.ɵdir = ɵɵdefineDirective({ type: DetectAllFacesVideoDirective, selectors: [["video", "allFaces", ""]], inputs: { with: "with", draw: "draw" }, exportAs: ["faces"], features: [ɵɵInheritDefinitionFeature] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DetectAllFacesVideoDirective, [{
        type: Directive,
        args: [{
                selector: 'video[allFaces]',
                exportAs: 'faces',
            }]
    }], function () { return [{ type: ElementRef }, { type: Overlay }, { type: Injector }]; }, { with: [{
            type: Input
        }], draw: [{
            type: Input
        }] }); })();

const _c0$1 = ["video"];
const _c1 = ["canvas"];
function WebcamComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 4);
    ɵɵlistener("click", function WebcamComponent_div_3_Template_div_click_0_listener() { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.rotateVideoInput(true); });
    ɵɵelementEnd();
} }
class WebcamComponent {
    constructor() {
        /** Defines the max width of the webcam area in px */
        this.width = 300;
        /** Defines the max height of the webcam area in px */
        this.height = 300;
        /** Defines base constraints to apply when requesting video track from UserMedia */
        this.videoOptions = WebcamComponent.DEFAULT_VIDEO_OPTIONS;
        /** Flag to enable/disable camera switch. If enabled, a switch icon will be displayed if multiple cameras were found */
        this.allowCameraSwitch = true;
        /** Flag to control whether an ImageData object is stored into the WebcamImage object. */
        this.captureImageData = false;
        /** The image type to use when capturing snapshots */
        this.imageType = WebcamComponent.DEFAULT_IMAGE_TYPE;
        /** The image quality to use when capturing snapshots (number between 0 and 1) */
        this.imageQuality = WebcamComponent.DEFAULT_IMAGE_QUALITY;
        /** EventEmitter which fires when an image has been captured */
        this.imageCapture = new EventEmitter();
        /** Emits a mediaError if webcam cannot be initialized (e.g. missing user permissions) */
        this.initError = new EventEmitter();
        /** Emits when the webcam video was clicked */
        this.imageClick = new EventEmitter();
        /** Emits the active deviceId after the active video device was switched */
        this.cameraSwitched = new EventEmitter();
        /** available video devices */
        this.availableVideoInputs = [];
        /** Indicates whether the video device is ready to be switched */
        this.videoInitialized = false;
        /** Index of active video in availableVideoInputs */
        this.activeVideoInputIndex = -1;
        /** MediaStream object in use for streaming UserMedia data */
        this.mediaStream = null;
        /** width and height of the active video stream */
        this.activeVideoSettings = null;
    }
    /**
     * If the given Observable emits, an image will be captured and emitted through 'imageCapture' EventEmitter
     */
    set trigger(trigger) {
        if (this.triggerSubscription) {
            this.triggerSubscription.unsubscribe();
        }
        // Subscribe to events from this Observable to take snapshots
        this.triggerSubscription = trigger.subscribe(() => {
            this.takeSnapshot();
        });
    }
    /**
     * If the given Observable emits, the active webcam will be switched to the one indicated by the emitted value.
     * @param switchCamera Indicates which webcam to switch to
     *   true: cycle forwards through available webcams
     *   false: cycle backwards through available webcams
     *   string: activate the webcam with the given id
     */
    set switchCamera(switchCamera) {
        if (this.switchCameraSubscription) {
            this.switchCameraSubscription.unsubscribe();
        }
        // Subscribe to events from this Observable to switch video device
        this.switchCameraSubscription = switchCamera.subscribe((value) => {
            if (typeof value === 'string') {
                // deviceId was specified
                this.switchToVideoInput(value);
            }
            else {
                // direction was specified
                this.rotateVideoInput(value !== false);
            }
        });
    }
    /**
     * Get MediaTrackConstraints to request streaming the given device
     * @param deviceId
     * @param baseMediaTrackConstraints base constraints to merge deviceId-constraint into
     * @returns
     */
    static getMediaConstraintsForDevice(deviceId, baseMediaTrackConstraints) {
        const result = baseMediaTrackConstraints ? baseMediaTrackConstraints : this.DEFAULT_VIDEO_OPTIONS;
        if (deviceId) {
            result.deviceId = { exact: deviceId };
        }
        return result;
    }
    /**
     * Tries to harvest the deviceId from the given mediaStreamTrack object.
     * Browsers populate this object differently; this method tries some different approaches
     * to read the id.
     * @param mediaStreamTrack
     * @returns deviceId if found in the mediaStreamTrack
     */
    static getDeviceIdFromMediaStreamTrack(mediaStreamTrack) {
        if (mediaStreamTrack.getSettings && mediaStreamTrack.getSettings() && mediaStreamTrack.getSettings().deviceId) {
            return mediaStreamTrack.getSettings().deviceId;
        }
        else if (mediaStreamTrack.getConstraints && mediaStreamTrack.getConstraints() && mediaStreamTrack.getConstraints().deviceId) {
            const deviceIdObj = mediaStreamTrack.getConstraints().deviceId;
            return WebcamComponent.getValueFromConstrainDOMString(deviceIdObj);
        }
    }
    /**
     * Tries to harvest the facingMode from the given mediaStreamTrack object.
     * Browsers populate this object differently; this method tries some different approaches
     * to read the value.
     * @param mediaStreamTrack
     * @returns facingMode if found in the mediaStreamTrack
     */
    static getFacingModeFromMediaStreamTrack(mediaStreamTrack) {
        if (mediaStreamTrack) {
            if (mediaStreamTrack.getSettings && mediaStreamTrack.getSettings() && mediaStreamTrack.getSettings().facingMode) {
                return mediaStreamTrack.getSettings().facingMode;
            }
            else if (mediaStreamTrack.getConstraints && mediaStreamTrack.getConstraints() && mediaStreamTrack.getConstraints().facingMode) {
                const facingModeConstraint = mediaStreamTrack.getConstraints().facingMode;
                return WebcamComponent.getValueFromConstrainDOMString(facingModeConstraint);
            }
        }
    }
    /**
     * Determines whether the given mediaStreamTrack claims itself as user facing
     * @param mediaStreamTrack
     */
    static isUserFacing(mediaStreamTrack) {
        const facingMode = WebcamComponent.getFacingModeFromMediaStreamTrack(mediaStreamTrack);
        return facingMode ? 'user' === facingMode.toLowerCase() : false;
    }
    /**
     * Extracts the value from the given ConstrainDOMString
     * @param constrainDOMString
     */
    static getValueFromConstrainDOMString(constrainDOMString) {
        if (constrainDOMString) {
            if (constrainDOMString instanceof String) {
                return String(constrainDOMString);
            }
            else if (Array.isArray(constrainDOMString) && Array(constrainDOMString).length > 0) {
                return String(constrainDOMString[0]);
            }
            else if (typeof constrainDOMString === 'object') {
                if (constrainDOMString['exact']) {
                    return String(constrainDOMString['exact']);
                }
                else if (constrainDOMString['ideal']) {
                    return String(constrainDOMString['ideal']);
                }
            }
        }
        return null;
    }
    ngAfterViewInit() {
        this.detectAvailableDevices()
            .then(() => {
            // start video
            this.switchToVideoInput(null);
        })
            .catch((err) => {
            this.initError.next({ message: err });
            // fallback: still try to load webcam, even if device enumeration failed
            this.switchToVideoInput(null);
        });
    }
    ngOnDestroy() {
        this.stopMediaTracks();
        this.unsubscribeFromSubscriptions();
    }
    /**
     * Takes a snapshot of the current webcam's view and emits the image as an event
     */
    takeSnapshot() {
        // set canvas size to actual video size
        const _video = this.nativeVideoElement;
        const dimensions = { width: this.width, height: this.height };
        if (_video.videoWidth) {
            dimensions.width = _video.videoWidth;
            dimensions.height = _video.videoHeight;
        }
        const _canvas = this.canvas.nativeElement;
        _canvas.width = dimensions.width;
        _canvas.height = dimensions.height;
        // paint snapshot image to canvas
        const context2d = _canvas.getContext('2d');
        context2d.drawImage(_video, 0, 0);
        // read canvas content as image
        const mimeType = this.imageType ? this.imageType : WebcamComponent.DEFAULT_IMAGE_TYPE;
        const quality = this.imageQuality ? this.imageQuality : WebcamComponent.DEFAULT_IMAGE_QUALITY;
        const dataUrl = _canvas.toDataURL(mimeType, quality);
        // get the ImageData object from the canvas' context.
        let imageData = null;
        if (this.captureImageData) {
            imageData = context2d.getImageData(0, 0, _canvas.width, _canvas.height);
        }
        this.imageCapture.next(new WebcamImage(dataUrl, mimeType, imageData));
    }
    /**
     * Switches to the next/previous video device
     * @param forward
     */
    rotateVideoInput(forward) {
        if (this.availableVideoInputs && this.availableVideoInputs.length > 1) {
            const increment = forward ? 1 : (this.availableVideoInputs.length - 1);
            const nextInputIndex = (this.activeVideoInputIndex + increment) % this.availableVideoInputs.length;
            this.switchToVideoInput(this.availableVideoInputs[nextInputIndex].deviceId);
        }
    }
    /**
     * Switches the camera-view to the specified video device
     */
    switchToVideoInput(deviceId) {
        this.videoInitialized = false;
        this.stopMediaTracks();
        this.initWebcam(deviceId, this.videoOptions);
    }
    /**
     * Event-handler for video resize event.
     * Triggers Angular change detection so that new video dimensions get applied
     */
    videoResize() {
        // here to trigger Angular change detection
    }
    get videoWidth() {
        const videoRatio = this.getVideoAspectRatio();
        return Math.min(this.width, this.height * videoRatio);
    }
    get videoHeight() {
        const videoRatio = this.getVideoAspectRatio();
        return 300;
        //return Math.min(this.height, this.width / videoRatio);
    }
    get videoStyleClasses() {
        let classes = '';
        if (this.isMirrorImage()) {
            classes += 'mirrored border-radius';
        }
        return classes.trim();
    }
    get nativeVideoElement() {
        return this.video.nativeElement;
    }
    /**
     * Returns the video aspect ratio of the active video stream
     */
    getVideoAspectRatio() {
        // calculate ratio from video element dimensions if present
        const videoElement = this.nativeVideoElement;
        if (videoElement.videoWidth && videoElement.videoWidth > 0 &&
            videoElement.videoHeight && videoElement.videoHeight > 0) {
            return videoElement.videoWidth / videoElement.videoHeight;
        }
        // nothing present - calculate ratio based on width/height params
        return this.width / this.height;
    }
    /**
     * Init webcam live view
     */
    initWebcam(deviceId, userVideoTrackConstraints) {
        const _video = this.nativeVideoElement;
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            // merge deviceId -> userVideoTrackConstraints
            const videoTrackConstraints = WebcamComponent.getMediaConstraintsForDevice(deviceId, userVideoTrackConstraints);
            navigator.mediaDevices.getUserMedia({ video: videoTrackConstraints })
                .then((stream) => {
                this.mediaStream = stream;
                _video.srcObject = stream;
                _video.play();
                this.activeVideoSettings = stream.getVideoTracks()[0].getSettings();
                const activeDeviceId = WebcamComponent.getDeviceIdFromMediaStreamTrack(stream.getVideoTracks()[0]);
                this.cameraSwitched.next(activeDeviceId);
                // Initial detect may run before user gave permissions, returning no deviceIds. This prevents later camera switches. (#47)
                // Run detect once again within getUserMedia callback, to make sure this time we have permissions and get deviceIds.
                this.detectAvailableDevices()
                    .then(() => {
                    this.activeVideoInputIndex = activeDeviceId ? this.availableVideoInputs
                        .findIndex((mediaDeviceInfo) => mediaDeviceInfo.deviceId === activeDeviceId) : -1;
                    this.videoInitialized = true;
                })
                    .catch(() => {
                    this.activeVideoInputIndex = -1;
                    this.videoInitialized = true;
                });
            })
                .catch((err) => {
                this.initError.next({ message: err.message, mediaStreamError: err });
            });
        }
        else {
            this.initError.next({ message: 'Cannot read UserMedia from MediaDevices.' });
        }
    }
    getActiveVideoTrack() {
        return this.mediaStream ? this.mediaStream.getVideoTracks()[0] : null;
    }
    isMirrorImage() {
        if (!this.getActiveVideoTrack()) {
            return false;
        }
        // check for explicit mirror override parameter
        {
            let mirror = 'auto';
            if (this.mirrorImage) {
                if (typeof this.mirrorImage === 'string') {
                    mirror = String(this.mirrorImage).toLowerCase();
                }
                else {
                    // WebcamMirrorProperties
                    if (this.mirrorImage.x) {
                        mirror = this.mirrorImage.x.toLowerCase();
                    }
                }
            }
            switch (mirror) {
                case 'always':
                    return true;
                case 'never':
                    return false;
            }
        }
        // default: enable mirroring if webcam is user facing
        return WebcamComponent.isUserFacing(this.getActiveVideoTrack());
    }
    /**
     * Stops all active media tracks.
     * This prevents the webcam from being indicated as active,
     * even if it is no longer used by this component.
     */
    stopMediaTracks() {
        if (this.mediaStream && this.mediaStream.getTracks) {
            // pause video to prevent mobile browser freezes
            this.nativeVideoElement.pause();
            // getTracks() returns all media tracks (video+audio)
            this.mediaStream.getTracks()
                .forEach((track) => track.stop());
        }
    }
    /**
     * Unsubscribe from all open subscriptions
     */
    unsubscribeFromSubscriptions() {
        if (this.triggerSubscription) {
            this.triggerSubscription.unsubscribe();
        }
        if (this.switchCameraSubscription) {
            this.switchCameraSubscription.unsubscribe();
        }
    }
    /**
     * Reads available input devices
     */
    detectAvailableDevices() {
        return new Promise((resolve, reject) => {
            WebcamUtil.getAvailableVideoInputs()
                .then((devices) => {
                this.availableVideoInputs = devices;
                resolve(devices);
            })
                .catch(err => {
                this.availableVideoInputs = [];
                reject(err);
            });
        });
    }
}
WebcamComponent.DEFAULT_VIDEO_OPTIONS = { facingMode: 'environment' };
WebcamComponent.DEFAULT_IMAGE_TYPE = 'image/jpeg';
WebcamComponent.DEFAULT_IMAGE_QUALITY = 0.7;
WebcamComponent.ɵfac = function WebcamComponent_Factory(t) { return new (t || WebcamComponent)(); };
WebcamComponent.ɵcmp = ɵɵdefineComponent({ type: WebcamComponent, selectors: [["facial-recognition-webcam"]], viewQuery: function WebcamComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$1, true);
        ɵɵstaticViewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.video = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.canvas = _t.first);
    } }, inputs: { width: "width", height: "height", videoOptions: "videoOptions", allowCameraSwitch: "allowCameraSwitch", mirrorImage: "mirrorImage", captureImageData: "captureImageData", imageType: "imageType", imageQuality: "imageQuality", trigger: "trigger", switchCamera: "switchCamera" }, outputs: { imageCapture: "imageCapture", initError: "initError", imageClick: "imageClick", cameraSwitched: "cameraSwitched" }, decls: 4, vars: 4, consts: [[1, "webcam-wrapper", 3, "click"], ["autoplay", "", "muted", "", "playsinline", "", "allFaces", "", 2, "height", "100%", 3, "width", "resize"], ["video", ""], ["class", "camera-switch", 3, "click", 4, "ngIf"], [1, "camera-switch", 3, "click"]], template: function WebcamComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵlistener("click", function WebcamComponent_Template_div_click_0_listener() { return ctx.imageClick.next(); });
        ɵɵelementStart(1, "video", 1, 2);
        ɵɵlistener("resize", function WebcamComponent_Template_video_resize_1_listener() { return ctx.videoResize(); });
        ɵɵelementEnd();
        ɵɵtemplate(3, WebcamComponent_div_3_Template, 1, 0, "div", 3);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵclassMap(ctx.videoStyleClasses);
        ɵɵproperty("width", ctx.videoWidth);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.allowCameraSwitch && ctx.availableVideoInputs.length > 1 && ctx.videoInitialized);
    } }, directives: [DetectAllFacesVideoDirective, NgIf], styles: [".border-radius[_ngcontent-%COMP%]{border-radius:8%}@media (max-width:600px){.border-radius[_ngcontent-%COMP%]{border-radius:50%}}.webcam-wrapper[_ngcontent-%COMP%]{display:inline-block;line-height:0;position:relative}.webcam-wrapper[_ngcontent-%COMP%]   video.mirrored[_ngcontent-%COMP%]{transform:scaleX(-1)}.webcam-wrapper[_ngcontent-%COMP%]   canvas[_ngcontent-%COMP%]{display:none}.webcam-wrapper[_ngcontent-%COMP%]   .camera-switch[_ngcontent-%COMP%]{background-color:rgba(0,0,0,.1);background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAE9UlEQVR42u2aT2hdRRTGf+cRQqghSqihdBFDkRISK2KDfzDWxHaRQHEhaINKqa1gKQhd6EZLN+IidCH+Q0oWIkVRC21BQxXRitVaSbKoJSGtYGoK2tQ/tU1jY5v0c5F54Xl7b/KSO/PyEt+3e5f75p7zzZwzZ74zUEIJJfyfYaEGllQGVAGZlENdBy6Z2cSiYFTSKkkfS/pH/nBF0kFJdUW9AiRVASeAukD8DgNrzOySrwEzng18KaDzALXuG8W3AiStAvqBisBRNg40mtlPxbYCOgvgPO4bncWW+JpVeDQXRQhIygDfA00F5r0XuNfMrgclQFI98DDQCNQA5ZFXqoCWBVp8XwHRHeEqcN7loy/NbHBesyqpQ1KfFj/6nC+ZvFaApFrgPaCZpYVvgCfNbDiRAElNwGFg+RIt/X8H2s2s9wYCJDUAR4HqJX7++RN40MwGpgmQVAH0AQ2BPz4AHHPl8nBOAqtyFWQjsA6oL4Ada81sPDv7uwImod8kvSJp9RyS8O2SXnb/DYVd2Y9VSroQ4ANXJO2WVJmixqh0kzMWwL4LkiqRtDnA4D1zmfE8j9g9AezcnAHaPcfXdbfdnPZ2Yps6+DwAvO/Z1naTdApY7Xng48BDZnY1MpMVQBuw3iXc5Tnb0wBwBPjUzP6eoezuArZ6svM0geJLkvZEYnl3nkntoqROSbckSW2Suj3ZOIangc7GPJuUtNGdFIfmMeavktoSSKiW9LMPw30Q8JqkekmjCbOZRhuclLQjgYSNxUBAj6RyZ9ATgUJpUtJTCSR8vpAEXHAyWK5BXYFIGHOlepSAloUk4NEYgyoknQhEwhFJ0e8h6VSaQeerCb5uZgdi9utxYBNwOUD93hIVXswM4INCi6K9wAszFC2DwLOBDjHbYp59karIUnRdzYy/3ClqVklaUhfwTICj7K25OqA7a4wWagVsm4Me/xzwg2cCqqONFzO7DPxSCAJi436GUBgHHguQD2oTlJ55oSzP9ybccsttSJw1szdjFOSnI/8dTCGZHwcORp4Nx7y3B1iZ8/sm4MW8/Euxg5wIsS/HaAp3zeP4/G7obRDXI4jiTIA22H7Xdc7X+S3A5lC7QBQ357aq3VAjCeSkwUfAJrfvz+R8A9ADLAtZB+TinpjC5JMA+//jwPZZnF8G7J+L8z4IWB/zbG+gIujVWfLBW/NStVMmqaG4POJRsIjix7h8IGnLQuoBbQki5sVAJHyYm7YkNaRRtXwQ8G1cHpX0iKRrgUjYno17Sf0LrQhJUkdCeHWkVITGJI0k1QeS3ikGSUzOyJUJJNznYneuOCnpTldcxa2kP3xJYqOeSDjqZG8ShJLnE8TTuMS6Iyu1BW7djZqkfo9N0QOuYJmYQddfB7RG+gLTNzqAY9FrL+5/nwEbvDdJJe3zzOrhNP3AWRqmk55t3ZcBuj3b2gb0Sbrbo/NNzk7fFzu7s/E5EiC+rrmeQU0Kx2skvRFoOx2ZzlmSdgbsw49JetvtBpk8nM64d/cGbNtJ0s7cGyJlwHeEv+t3nqnLSgPAUOSGyG3AHUxdzqoJbEcvcL+ZTeTeEapzJKxgaeOcc/7Mf06D7kFrguS0VDAMtGadv+E47DT9tcChJej8ISfpD+abgTe45uOkFi8mnQ+JBVQ+d4VXuOptjavcyot8pq86mfwk8LWZnaOEEkoooYQSSojDv8AhQNeGfe0jAAAAAElFTkSuQmCC\");background-position:50%;background-repeat:no-repeat;background-size:80%;border-radius:5px;cursor:pointer;height:48px;position:absolute;right:13px;top:10px;transition:background-color .2s ease;width:48px}.webcam-wrapper[_ngcontent-%COMP%]   .camera-switch[_ngcontent-%COMP%]:hover{background-color:rgba(0,0,0,.18)}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(WebcamComponent, [{
        type: Component,
        args: [{
                selector: 'facial-recognition-webcam',
                templateUrl: './webcam.component.html',
                styleUrls: ['./webcam.component.scss']
            }]
    }], null, { width: [{
            type: Input
        }], height: [{
            type: Input
        }], videoOptions: [{
            type: Input
        }], allowCameraSwitch: [{
            type: Input
        }], mirrorImage: [{
            type: Input
        }], captureImageData: [{
            type: Input
        }], imageType: [{
            type: Input
        }], imageQuality: [{
            type: Input
        }], imageCapture: [{
            type: Output
        }], initError: [{
            type: Output
        }], imageClick: [{
            type: Output
        }], cameraSwitched: [{
            type: Output
        }], video: [{
            type: ViewChild,
            args: ['video', { static: true }]
        }], canvas: [{
            type: ViewChild,
            args: ['canvas', { static: true }]
        }], trigger: [{
            type: Input
        }], switchCamera: [{
            type: Input
        }] }); })();

function FacialRecognitionComponent_ng_container_17_div_1_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 22);
    ɵɵelementStart(1, "div", 23);
    ɵɵelementStart(2, "span", 24);
    ɵɵtext(3, "Rostro Detectado");
    ɵɵelementEnd();
    ɵɵelement(4, "br");
    ɵɵelementStart(5, "small", 25);
    ɵɵtext(6, "Presiona Iniciar reto.");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function FacialRecognitionComponent_ng_container_17_div_1_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 26);
    ɵɵelementStart(1, "div", 27);
    ɵɵelementStart(2, "span", 24);
    ɵɵtext(3, "Centrar Rostro");
    ɵɵelementEnd();
    ɵɵelement(4, "br");
    ɵɵelementStart(5, "small", 25);
    ɵɵtext(6, "Para iniciar.");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function FacialRecognitionComponent_ng_container_17_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 18);
    ɵɵelementStart(1, "div", 19);
    ɵɵtemplate(2, FacialRecognitionComponent_ng_container_17_div_1_div_1_div_2_Template, 7, 0, "div", 20);
    ɵɵtemplate(3, FacialRecognitionComponent_ng_container_17_div_1_div_1_div_3_Template, 7, 0, "div", 21);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵɵnextContext(3);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r10.response.length > 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r10.response.length == 0);
} }
function FacialRecognitionComponent_ng_container_17_div_1_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 30);
    ɵɵelementStart(1, "div", 23);
    ɵɵelementStart(2, "span", 24);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelement(4, "br");
    ɵɵelementStart(5, "small", 25);
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵɵnextContext(4);
    ɵɵadvance(3);
    ɵɵtextInterpolate(ctx_r14.question);
    ɵɵadvance(3);
    ɵɵtextInterpolate(ctx_r14.question_subtitle);
} }
function FacialRecognitionComponent_ng_container_17_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 28);
    ɵɵtemplate(1, FacialRecognitionComponent_ng_container_17_div_1_div_2_div_1_Template, 7, 2, "div", 29);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r11.challengeActive && !ctx_r11.success);
} }
function FacialRecognitionComponent_ng_container_17_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 15);
    ɵɵtemplate(1, FacialRecognitionComponent_ng_container_17_div_1_div_1_Template, 4, 2, "div", 16);
    ɵɵtemplate(2, FacialRecognitionComponent_ng_container_17_div_1_div_2_Template, 2, 1, "div", 17);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r2.challengeActive && !ctx_r2.loading);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.challengeActive);
} }
function FacialRecognitionComponent_ng_container_17_div_2_div_1_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 34);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r17.countdown_response["seconds"] - 30, " ");
} }
function FacialRecognitionComponent_ng_container_17_div_2_div_1_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 34);
    ɵɵtext(1, " 30 ");
    ɵɵelementEnd();
} }
function FacialRecognitionComponent_ng_container_17_div_2_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1, " Restan ");
    ɵɵtemplate(2, FacialRecognitionComponent_ng_container_17_div_2_div_1_div_1_span_2_Template, 2, 1, "span", 33);
    ɵɵtemplate(3, FacialRecognitionComponent_ng_container_17_div_2_div_1_div_1_span_3_Template, 2, 0, "span", 33);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵɵnextContext(4);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r16.countdown_response["seconds"] >= 1);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r16.countdown_response["seconds"] >= 1);
} }
function FacialRecognitionComponent_ng_container_17_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 32);
    ɵɵtemplate(1, FacialRecognitionComponent_ng_container_17_div_2_div_1_div_1_Template, 4, 2, "div", 8);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r15.countdown_response);
} }
function FacialRecognitionComponent_ng_container_17_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 0);
    ɵɵtemplate(1, FacialRecognitionComponent_ng_container_17_div_2_div_1_Template, 2, 1, "div", 31);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.challengeActive && !ctx_r3.success);
} }
function FacialRecognitionComponent_ng_container_17_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 0);
    ɵɵelementStart(1, "div", 35);
    ɵɵelementStart(2, "facial-recognition-webcam", 36);
    ɵɵlistener("imageCapture", function FacialRecognitionComponent_ng_container_17_div_4_Template_facial_recognition_webcam_imageCapture_2_listener($event) { ɵɵrestoreView(_r20); const ctx_r19 = ɵɵnextContext(2); return ctx_r19.handleImage($event); })("cameraSwitched", function FacialRecognitionComponent_ng_container_17_div_4_Template_facial_recognition_webcam_cameraSwitched_2_listener($event) { ɵɵrestoreView(_r20); const ctx_r21 = ɵɵnextContext(2); return ctx_r21.cameraWasSwitched($event); })("initError", function FacialRecognitionComponent_ng_container_17_div_4_Template_facial_recognition_webcam_initError_2_listener($event) { ɵɵrestoreView(_r20); const ctx_r22 = ɵɵnextContext(2); return ctx_r22.handleInitError($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵproperty("height", 400)("width", 400)("trigger", ctx_r4.triggerObservable)("allowCameraSwitch", ctx_r4.allowCameraSwitch)("switchCamera", ctx_r4.nextWebcamObservable)("videoOptions", ctx_r4.videoOptions)("imageQuality", 0.9);
} }
function FacialRecognitionComponent_ng_container_17_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 0);
    ɵɵelementStart(1, "div", 37);
    ɵɵelementStart(2, "div", 30);
    ɵɵelementStart(3, "div", 38);
    ɵɵelement(4, "i", 39);
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 40);
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(6);
    ɵɵtextInterpolate1(" Reto ", ctx_r5.question_id + 1, " completado ");
} }
function FacialRecognitionComponent_ng_container_17_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 41);
    ɵɵelementStart(1, "div", 4);
    ɵɵelementStart(2, "div", 40);
    ɵɵelementStart(3, "h5");
    ɵɵtext(4, "Preparando tu f\u00E9 de vida...");
    ɵɵelementEnd();
    ɵɵtext(5, " Podr\u00E1s comenzar tu prueba en un momento");
    ɵɵelementEnd();
    ɵɵelement(6, "i", 42);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function FacialRecognitionComponent_ng_container_17_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 0);
    ɵɵelementStart(1, "div", 1);
    ɵɵelement(2, "img", 43);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵpropertyInterpolate1("src", "./assets/", ctx_r7.asset_path, "/public/images/preparando_fe_de_vida.svg", ɵɵsanitizeUrl);
} }
function FacialRecognitionComponent_ng_container_17_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 45);
    ɵɵlistener("click", function FacialRecognitionComponent_ng_container_17_div_8_div_1_Template_div_click_0_listener() { ɵɵrestoreView(_r25); const ctx_r24 = ɵɵnextContext(3); return ctx_r24.startChallenge(); });
    ɵɵelementStart(1, "button", 46);
    ɵɵlistener("click", function FacialRecognitionComponent_ng_container_17_div_8_div_1_Template_button_click_1_listener() { ɵɵrestoreView(_r25); const ctx_r26 = ɵɵnextContext(3); return ctx_r26.next(); });
    ɵɵtext(2, "Iniciar Reto ");
    ɵɵelement(3, "span", 7);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function FacialRecognitionComponent_ng_container_17_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 0);
    ɵɵtemplate(1, FacialRecognitionComponent_ng_container_17_div_8_div_1_Template, 4, 0, "div", 44);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r8.challengeActive && !ctx_r8.loading && ctx_r8.response.length > 0);
} }
function FacialRecognitionComponent_ng_container_17_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 47);
    ɵɵelementStart(1, "div", 48);
    ɵɵelementStart(2, "div", 49);
    ɵɵtext(3, "Felicitaciones");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 1);
    ɵɵelement(5, "img", 43);
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 48);
    ɵɵelementStart(7, "div", 26);
    ɵɵtext(8, "Hemos completado tu f\u00E9 de vida");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(9, "div", 4);
    ɵɵelementStart(10, "div", 50);
    ɵɵtext(11, "Ahora puedes continuar con tu verificaci\u00F3n intermedia con tu documento de identidad.");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(12, "div", 51);
    ɵɵelementStart(13, "button", 52);
    ɵɵlistener("click", function FacialRecognitionComponent_ng_container_17_div_9_Template_button_click_13_listener() { ɵɵrestoreView(_r28); const ctx_r27 = ɵɵnextContext(2); return ctx_r27.finalizar(); });
    ɵɵtext(14, "Contin\u00FAar ");
    ɵɵelement(15, "span", 7);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵɵnextContext(2);
    ɵɵadvance(5);
    ɵɵpropertyInterpolate1("src", "./assets/", ctx_r9.asset_path, "/public/images/felicidades.svg", ɵɵsanitizeUrl);
} }
function FacialRecognitionComponent_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, FacialRecognitionComponent_ng_container_17_div_1_Template, 3, 2, "div", 10);
    ɵɵtemplate(2, FacialRecognitionComponent_ng_container_17_div_2_Template, 2, 1, "div", 11);
    ɵɵelementStart(3, "div");
    ɵɵtemplate(4, FacialRecognitionComponent_ng_container_17_div_4_Template, 3, 7, "div", 11);
    ɵɵelementEnd();
    ɵɵtemplate(5, FacialRecognitionComponent_ng_container_17_div_5_Template, 7, 1, "div", 11);
    ɵɵtemplate(6, FacialRecognitionComponent_ng_container_17_div_6_Template, 7, 0, "div", 12);
    ɵɵtemplate(7, FacialRecognitionComponent_ng_container_17_div_7_Template, 3, 1, "div", 13);
    ɵɵtemplate(8, FacialRecognitionComponent_ng_container_17_div_8_Template, 2, 1, "div", 13);
    ɵɵtemplate(9, FacialRecognitionComponent_ng_container_17_div_9_Template, 16, 1, "div", 14);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.response && !ctx_r0.success);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.response && !ctx_r0.success);
    ɵɵadvance(1);
    ɵɵclassProp("d-none", ctx_r0.loading)("d-block", !ctx_r0.loading);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r0.success);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.show_success_action);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.loading);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.loading);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.response && !ctx_r0.success);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.success);
} }
function FacialRecognitionComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 53);
    ɵɵelementStart(1, "div", 0);
    ɵɵelementStart(2, "div", 4);
    ɵɵelementStart(3, "span", 54);
    ɵɵelementStart(4, "a", 55);
    ɵɵlistener("click", function FacialRecognitionComponent_div_18_Template_a_click_4_listener() { ɵɵrestoreView(_r30); const ctx_r29 = ɵɵnextContext(); return ctx_r29.changeStatusFacialRecognition(); });
    ɵɵtext(5, "\u00BFTienes problemas para continuar?");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
class FacialRecognitionComponent {
    constructor(countdown, faceDetectorService, faceApiCompare, faceApiModel, _httpService) {
        this.countdown = countdown;
        this.faceDetectorService = faceDetectorService;
        this.faceApiCompare = faceApiCompare;
        this.faceApiModel = faceApiModel;
        this._httpService = _httpService;
        // toggle webcam on/off
        this.showWebcam = true;
        this.allowCameraSwitch = true;
        this.multipleWebcamsAvailable = false;
        this.facingMode = 'user';
        this.messages = [];
        // latest snapshot
        this.webcamImage = null;
        // webcam snapshot trigger
        this.trigger = new Subject();
        // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
        this.nextWebcam = new Subject();
        this.response = [];
        this.challengeActive = false;
        //private tasksList: any[] = ['happy', 'neutral', 'surprised', 'sad'];
        this.tasksList = ['happy', 'happy', 'happy', 'happy', 'happy', 'happy', 'happy', 'happy', 'happy', 'happy', 'happy', 'happy'];
        this.tasksListDetail = [
            { 'expression': 'happy', 'icon': '<img src=\'./assets/public/images/gestures/happy/focus.svg\'/>' },
            { 'expression': 'neutral', 'icon': '<img src=\'./assets/public/images/gestures/neutral/focus.svg\'/>' },
            { 'expression': 'surprised', 'icon': '<img src=\'./assets/public/images/gestures/surprised/focus.svg\'/>' },
            { 'expression': 'sad', 'icon': '<i class=\'fa-sad-tear fa-3x\'></i>' }
        ];
        this.tasks = [];
        this.delay = 0;
        this.expression = null;
        this.question = '';
        this.question_subtitle = '';
        this.question_id = 0;
        this.iteration_question_count = 0;
        this.success = false;
        this.success_finger = null;
        this.icono = '';
        this.step1 = true;
        this.step2 = false;
        this.loading = true;
        this.show_success_action = false;
        this.subscriptions = [];
        this.asset_path = '';
        this.fails = 1;
        this.detected = new EventEmitter();
        this.finish = new EventEmitter();
        this.current_view = new EventEmitter();
        this.event = new EventEmitter();
        this.show_help = false;
        this.validateGesture = (expression, response) => {
            if (expression === this.tasks[this.question_id]) {
                this.iteration_question_count++;
                if (this.iteration_question_count > 4) {
                    if (this.question_id < 3) {
                        this.nextChallenge();
                    }
                    else {
                        //alert('');
                        this.success = true;
                        this.success_finger = response[0]['descriptor'];
                        //this.finish.emit({'success': this.success, 'descriptor': this.success_finger});
                    }
                    this.show_success_action = false;
                }
                else if (this.iteration_question_count > 3) {
                    this.icono = "<img src=\'./assets/public/images/gestures/" + this.expression + "/success.svg\'/>";
                    // this.question = "";
                    // this.question_subtitle = "";
                    this.show_success_action = true;
                }
            }
            else {
                if (this.show_success_action) {
                    this.iteration_question_count++;
                    if (this.iteration_question_count > 4) {
                        if (this.question_id < 5) {
                            this.nextChallenge();
                        }
                        else {
                            //alert('');
                            this.success = true;
                            this.success_finger = response[0]['descriptor'];
                            this.finish.emit({ 'success': this.success, 'descriptor': this.success_finger });
                        }
                        this.show_success_action = false;
                    }
                    else if (this.iteration_question_count > 3) {
                        this.icono = "<img src=\'./assets/public/images/gestures/" + this.expression + "/success.svg\'/>";
                        // this.question = "";
                        // this.question_subtitle = "";
                        this.show_success_action = true;
                    }
                }
            }
        };
        this.nextChallenge = () => {
            this.iteration_question_count = 0;
            this.question_id++;
            this.question = this.generateAction(this.tasks[this.question_id]);
            this.question_subtitle = this.generateActionSubtitle(this.tasks[this.question_id]);
            this.icono = this.obtenerIcono().icon;
        };
        this.obtenerExpresion = (obj) => {
            let i = 0;
            let max = 0;
            let expression = '';
            if (!isNullOrUndefined(obj)) {
                if (obj.length > 0) {
                    let data = obj[0]['expressions'];
                    Object.keys(data).forEach(function (key) {
                        if (i == 0) {
                            max = data[key];
                            expression = key;
                        }
                        else {
                            if (data[key] > max) {
                                max = data[key];
                                expression = key;
                            }
                        }
                        i++;
                    });
                }
            }
            return expression;
        };
        this.startChallenge = () => {
            this.success = false;
            this.challengeActive = true;
            this.tasks = this.aleatorios(this.tasksList, 6);
            this.tasks = this.actualizarIntermedios(this.tasks);
            this.question_id = 0;
            this.icono = this.obtenerIcono().icon;
            this.countdown.start();
            this.question = this.generateAction(this.tasks[this.question_id]);
            this.question_subtitle = this.generateActionSubtitle(this.tasks[this.question_id]);
        };
        this.actualizarIntermedios = (tasks) => {
            tasks[1] = 'neutral';
            tasks[3] = 'neutral';
            tasks[5] = 'neutral';
            return tasks;
        };
        this.finalizar = () => {
            this.finish.emit({ 'success': this.success, 'descriptor': this.success_finger });
        };
        this.obtenerIcono = () => {
            return this.tasksListDetail.find(el => el.expression == this.tasks[this.question_id]);
            // console.log(icono);
            // let response = "";
            // if(icono==="happy") {
            //   response = "<img src=\'./assets/public/images/gestures/happy/focus.svg\'/>"
            // } else if(icono==="neutral") {
            //   response = "<img src=\'./assets/public/images/gestures/sad/focus.svg\'/>"
            // } else if(icono==="surprised") {
            //   response = "<img src=\'./assets/public/images/gestures/open_mouse/focus.svg\'/>"
            // }
            // return response;
        };
        this.generateAction = (option) => {
            let response = '';
            switch (option) {
                case 'sad':
                    response = 'Haz cara de tristeza.';
                    break;
                case 'happy':
                    response = 'Sonríe';
                    break;
                case 'neutral':
                    response = 'No haga ningún gesto';
                    break;
                case 'surprised':
                    response = 'Abra la boca';
                    break;
                default:
                    break;
            }
            return response;
        };
        this.generateActionSubtitle = (option) => {
            let response = '';
            switch (option) {
                case 'sad':
                    response = 'Haz cara de tristeza por unos segundos.';
                    break;
                case 'happy':
                    response = 'Sonríe por unos segundos';
                    break;
                case 'neutral':
                    response = 'No haga ningún gesto por unos segundos';
                    break;
                case 'surprised':
                    response = 'Abre la boca por unos segundos';
                    break;
                default:
                    break;
            }
            return response;
        };
        this.aleatorios = (lista, cant) => {
            return [...lista].sort(() => (Math.random() > 0.5 ? 1 : -1)).slice(0, cant);
        };
        this.next = () => {
            this.step1 = false;
            this.step2 = true;
            this.current_view.emit(2);
        };
        this.back = () => {
            this.step1 = true;
            this.step2 = false;
            this.show_success_action = false;
            this.challengeActive = false;
            this.countdown.stop();
            this.delay = 0;
            this.current_view.emit(1);
        };
        this.changeStatusFacialRecognition = () => __awaiter(this, void 0, void 0, function* () {
            swal.fire({
                title: '',
                html: "¿Desea desactivar el reconocimiento facial?",
                showCancelButton: true,
                confirmButtonText: 'Si'
            }).then((result) => __awaiter(this, void 0, void 0, function* () {
                if (result.value) {
                    const params = {
                        name: 'person$active_facial_recognition$post',
                        params: {
                            request: {
                                'idPerson': this._config.identifierPerson,
                                'active': false
                            },
                            path: {},
                            body: {}
                        }
                    };
                    const response = yield this._httpService.executeRequest(params.name, params.params, true).toPromise();
                    this.event.emit({
                        name: 'facial_recognition_disabled',
                        response: response
                    });
                }
            }));
        });
    }
    set config(value) {
        this._config = value;
        this.asset_path = this._config.asset_path ? this._config.asset_path : '';
    }
    ngOnInit() {
        this.current_view.emit(1);
        this.readAvailableVideoInputs();
        this.countdown.startLimited();
        this.subscriptions.push(this.countdown.countdownService.subscribe((response) => {
            if (response) {
                if (response['seconds'] == 30) {
                    this.challengeActive = false;
                    this.show_success_action = false;
                    this.countdown.stop();
                    this.delay = 0;
                }
                this.countdown_response = response;
            }
        }));
        this.subscriptions.push(this.countdown.countdownLimitedService.subscribe((response) => {
            if (response) {
                if (response['status'] == 'finish') {
                    this.countdown.stopLimited;
                    this.show_help = true;
                }
            }
        }));
        this.subscriptions.push(this.faceDetectorService.responseFaceApi.subscribe((response) => {
            if (!this.success) {
                if (!isNullOrUndefined(response)) {
                    this.loading = false;
                    if (response.length === 0) {
                        this.expression = "";
                        this.detected.emit(false);
                        if (this.delay > 1) {
                            if (this.challengeActive) {
                                this.fails++;
                            }
                            this.challengeActive = false;
                            this.countdown.stop();
                            this.delay = 0;
                        }
                        else {
                            this.delay++;
                        }
                    }
                    else if (response.length >= 1) {
                        this.detected.emit(true);
                        this.expression = this.obtenerExpresion(response);
                        this.delay = 0;
                        if (this.challengeActive) {
                            this.validateGesture(this.expression, response);
                        }
                        else {
                            this.show_success_action = false;
                        }
                    }
                    else {
                        this.challengeActive = false;
                        this.countdown.stop();
                        this.delay = 0;
                        this.show_success_action = false;
                        this.fails++;
                        this.detected.emit(false);
                    }
                }
                else {
                    this.show_success_action = false;
                    this.detected.emit(false);
                }
                this.response = response;
            }
        }));
    }
    triggerSnapshot() {
        this.trigger.next();
    }
    toggleWebcam() {
        this.showWebcam = !this.showWebcam;
    }
    handleInitError(error) {
        this.messages.push(error);
        if (error.mediaStreamError && error.mediaStreamError.name === 'NotAllowedError') {
            this.addMessage('User denied camera access');
        }
    }
    showNextWebcam(directionOrDeviceId) {
        this.nextWebcam.next(directionOrDeviceId);
    }
    handleImage(webcamImage) {
        this.addMessage('Received webcam image');
        this.webcamImage = webcamImage;
    }
    cameraWasSwitched(deviceId) {
        this.addMessage('Active device: ' + deviceId);
        this.deviceId = deviceId;
        this.readAvailableVideoInputs();
    }
    addMessage(message) {
        console.log(message);
        this.messages.unshift(message);
    }
    get triggerObservable() {
        return this.trigger.asObservable();
    }
    get nextWebcamObservable() {
        return this.nextWebcam.asObservable();
    }
    get videoOptions() {
        const result = {};
        if (this.facingMode && this.facingMode !== '') {
            result.facingMode = { ideal: this.facingMode };
        }
        return result;
    }
    readAvailableVideoInputs() {
        WebcamUtil.getAvailableVideoInputs()
            .then((mediaDevices) => {
            this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
        });
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            // prevent memory leak when component destroyed
            this.subscriptions.forEach(s => s.unsubscribe());
        }
    }
}
FacialRecognitionComponent.ɵfac = function FacialRecognitionComponent_Factory(t) { return new (t || FacialRecognitionComponent)(ɵɵdirectiveInject(CountdownService), ɵɵdirectiveInject(FaceDetectorRespService), ɵɵdirectiveInject(FaceCompareService), ɵɵdirectiveInject(ModelLoaderService), ɵɵdirectiveInject(HttpService)); };
FacialRecognitionComponent.ɵcmp = ɵɵdefineComponent({ type: FacialRecognitionComponent, selectors: [["lib-facial-recognition"]], inputs: { config: "config" }, outputs: { detected: "detected", finish: "finish", current_view: "current_view", event: "event" }, decls: 19, vars: 11, consts: [[1, "row"], [1, "col-12", "col-md-6", "offset-md-3", "text-center"], [1, "img-c", 3, "src"], [1, "row", "pt-3"], [1, "col-12", "text-center"], [1, "col-12", "col-md-4", "offset-md-4", "text-center"], [1, "btn", "btn-primary", "btn-block", "btn-primary", "small", 3, "click"], [1, "fas", "fa-arrow-right", "ml-1"], [4, "ngIf"], ["class", "w-100 pt-2", 4, "ngIf"], ["class", "row pt-2", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["class", "row pt-3 pt-md-5", 4, "ngIf"], ["class", "row ", 4, "ngIf"], ["class", "row pt-4 pt-md-5", 4, "ngIf"], [1, "row", "pt-2"], ["class", "col pt-3 pt-md-5 text-center", 4, "ngIf"], ["class", "col pt-3 pt-md-5", 4, "ngIf"], [1, "col", "pt-3", "pt-md-5", "text-center"], [1, "pb-2"], ["class", "w-100", 4, "ngIf"], ["class", "", 4, "ngIf"], [1, "w-100"], ["role", "alert", 1, "alert", "alert-success"], [1, "alert-heading"], [2, "font-size", "0.6rem!important"], [1, ""], ["role", "alert", 1, "alert", "alert-warning"], [1, "col", "pt-3", "pt-md-5"], ["class", "w-100 text-center ", 4, "ngIf"], [1, "w-100", "text-center"], ["class", "col text-center ", 4, "ngIf"], [1, "col", "text-center"], ["class", "pr-3", 4, "ngIf"], [1, "pr-3"], [1, "col-10", "offset-1", "col-md-8", "offset-md-2", "text-center"], [3, "height", "width", "trigger", "allowCameraSwitch", "switchCamera", "videoOptions", "imageQuality", "imageCapture", "cameraSwitched", "initError"], [1, "col"], [1, "font-weight-bold", "font-primary"], [1, "fas", "fa-check-circle", "fa-2x"], [1, "font-weight-bold", "pb-4"], [1, "row", "pt-3", "pt-md-5"], [1, "fas", "fa-circle-notch", "fa-spin", "fa-3x", "font-primary"], [1, "img-d", 3, "src"], ["class", "col-12 col-md-4 offset-md-4 pt-3 text-right", 3, "click", 4, "ngIf"], [1, "col-12", "col-md-4", "offset-md-4", "pt-3", "text-right", 3, "click"], [1, "btn", "btn-block", "btn-primary", "btn-primary", "small", 3, "click"], [1, "row", "pt-4", "pt-md-5"], [1, "col-12", "text-center", "font-weight-bold"], [1, "ak-title-msg"], [1, "pt-2"], [1, "col-12", "col-md-4", "offset-md-4", "text-right"], [1, "btn", "btn-block", "btn-primary", "btn-primary", "mt-4", "small", 3, "click"], [1, "w-100", "pt-2"], [1, "pt-2", "pb-1", "font-weight-light"], ["href", "javascript:void()", 3, "click"]], template: function FacialRecognitionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div");
        ɵɵelementStart(1, "div", 0);
        ɵɵelementStart(2, "div", 1);
        ɵɵelement(3, "img", 2);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(4, "div", 3);
        ɵɵelementStart(5, "div", 4);
        ɵɵelementStart(6, "h5");
        ɵɵtext(7, "\u00BFC\u00F3mo comenzar tu prueba de f\u00E9 de vida?");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(8, "div", 0);
        ɵɵelementStart(9, "div", 4);
        ɵɵtext(10, " Primero, coloca tu cara en el marco de la c\u00E1mara. Luego haz las acciones como sonreir y ser serio. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(11, "div", 3);
        ɵɵelementStart(12, "div", 5);
        ɵɵelementStart(13, "button", 6);
        ɵɵlistener("click", function FacialRecognitionComponent_Template_button_click_13_listener() { return ctx.next(); });
        ɵɵtext(14, "Contin\u00FAar ");
        ɵɵelement(15, "span", 7);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(16, "div");
        ɵɵtemplate(17, FacialRecognitionComponent_ng_container_17_Template, 10, 12, "ng-container", 8);
        ɵɵelementEnd();
        ɵɵtemplate(18, FacialRecognitionComponent_div_18_Template, 6, 0, "div", 9);
    } if (rf & 2) {
        ɵɵclassProp("d-block", ctx.step1)("d-none", !ctx.step1);
        ɵɵadvance(3);
        ɵɵpropertyInterpolate1("src", "./assets/", ctx.asset_path, "/public/images/bienvenida2.svg", ɵɵsanitizeUrl);
        ɵɵadvance(13);
        ɵɵclassProp("d-block", ctx.step2)("d-none", !ctx.step2);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showWebcam);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.fails > 3 || ctx.show_help);
    } }, directives: [NgIf, WebcamComponent], styles: [".undetected[_ngcontent-%COMP%]{color:red}.detected[_ngcontent-%COMP%]{color:green}.img-c[_ngcontent-%COMP%]{width:90%}.ak-title-msg[_ngcontent-%COMP%]{color:#555;font-size:24px;font-weight:700}.alert[_ngcontent-%COMP%]{padding:.15rem 1.25rem!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FacialRecognitionComponent, [{
        type: Component,
        args: [{
                selector: 'lib-facial-recognition',
                templateUrl: './facial-recognition.component.html',
                styleUrls: ['./facial-recognition.component.css'],
            }]
    }], function () { return [{ type: CountdownService }, { type: FaceDetectorRespService }, { type: FaceCompareService }, { type: ModelLoaderService }, { type: HttpService }]; }, { config: [{
            type: Input
        }], detected: [{
            type: Output
        }], finish: [{
            type: Output
        }], current_view: [{
            type: Output
        }], event: [{
            type: Output
        }] }); })();

class DetectAllFacesImgDirective extends AbstractDetectDirective {
    constructor(el, overlay, injector) {
        super(el, overlay, injector);
        this.with = [];
        this.draw = true;
        this.type = 'all';
        this.stream = false;
    }
}
DetectAllFacesImgDirective.ɵfac = function DetectAllFacesImgDirective_Factory(t) { return new (t || DetectAllFacesImgDirective)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(Overlay), ɵɵdirectiveInject(Injector)); };
DetectAllFacesImgDirective.ɵdir = ɵɵdefineDirective({ type: DetectAllFacesImgDirective, selectors: [["img", "allFaces", ""]], inputs: { with: "with", draw: "draw" }, exportAs: ["faces"], features: [ɵɵInheritDefinitionFeature] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DetectAllFacesImgDirective, [{
        type: Directive,
        args: [{
                selector: 'img[allFaces]',
                exportAs: 'faces',
            }]
    }], function () { return [{ type: ElementRef }, { type: Overlay }, { type: Injector }]; }, { with: [{
            type: Input
        }], draw: [{
            type: Input
        }] }); })();

class DetectSingleFaceImgDirective extends AbstractDetectDirective {
    constructor(el, overlay, injector) {
        super(el, overlay, injector);
        this.with = [];
        this.draw = true;
        this.type = 'single';
        this.stream = false;
    }
    ngOnInit() {
        this.task = new DetectTask({
            type: this.type,
            tokens: this.with,
            draw: this.draw,
            realtime: this.stream,
        });
    }
}
DetectSingleFaceImgDirective.ɵfac = function DetectSingleFaceImgDirective_Factory(t) { return new (t || DetectSingleFaceImgDirective)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(Overlay), ɵɵdirectiveInject(Injector)); };
DetectSingleFaceImgDirective.ɵdir = ɵɵdefineDirective({ type: DetectSingleFaceImgDirective, selectors: [["img", "singleFace", ""]], inputs: { with: "with", draw: "draw" }, exportAs: ["face"], features: [ɵɵInheritDefinitionFeature] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DetectSingleFaceImgDirective, [{
        type: Directive,
        args: [{
                selector: 'img[singleFace]',
                exportAs: 'face',
            }]
    }], function () { return [{ type: ElementRef }, { type: Overlay }, { type: Injector }]; }, { with: [{
            type: Input
        }], draw: [{
            type: Input
        }] }); })();

const MODULES = [OverlayModule, PortalModule, CommonModule, BrowserModule];
class FacialRecognitionModule {
    static forRoot(options) {
        return {
            ngModule: FacialRecognitionModule,
            providers: [
                {
                    provide: ModelsUrl,
                    useValue: options.modelsUrl,
                },
                ModelLoaderService,
                FaceDetectorService,
                ...[
                    options.faceDetectionOptions
                        ? {
                            provide: FaceDetectionOptions,
                            useValue: options.faceDetectionOptions,
                        }
                        : [],
                ],
            ],
        };
    }
}
FacialRecognitionModule.ɵmod = ɵɵdefineNgModule({ type: FacialRecognitionModule });
FacialRecognitionModule.ɵinj = ɵɵdefineInjector({ factory: function FacialRecognitionModule_Factory(t) { return new (t || FacialRecognitionModule)(); }, providers: [ModelLoaderService, CountdownService, FaceDetectorRespService, FaceCompareService], imports: [[
            MODULES
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FacialRecognitionModule, { declarations: [FacialRecognitionComponent,
        DetectionResultComponent,
        DetectAllFacesImgDirective,
        DetectSingleFaceImgDirective,
        DetectAllFacesVideoDirective,
        WebcamComponent], imports: [OverlayModule, PortalModule, CommonModule, BrowserModule], exports: [DetectAllFacesImgDirective,
        DetectSingleFaceImgDirective,
        DetectAllFacesVideoDirective,
        FacialRecognitionComponent,
        WebcamComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(FacialRecognitionModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FacialRecognitionComponent,
                    DetectionResultComponent,
                    DetectAllFacesImgDirective,
                    DetectSingleFaceImgDirective,
                    DetectAllFacesVideoDirective,
                    WebcamComponent
                ],
                imports: [
                    MODULES
                ],
                providers: [ModelLoaderService, CountdownService, FaceDetectorRespService, FaceCompareService],
                exports: [
                    DetectAllFacesImgDirective,
                    DetectSingleFaceImgDirective,
                    DetectAllFacesVideoDirective,
                    FacialRecognitionComponent,
                    WebcamComponent
                ],
                entryComponents: [DetectionResultComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of facial-recognition
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AgeAndGenderModel, AgeAndGenderToken, DescriptorsFeatureToken, DetectAllFacesImgDirective, DetectAllFacesVideoDirective, DetectSingleFaceImgDirective, DetectTask, ExpressionsFeatureToken, FaceCompareService, FaceDetectionOptions, FaceDetectorRespService, FaceDetectorService, FaceExpressionModel, FaceLandmarkModel, FaceRecognitionModel, FacialRecognitionComponent, FacialRecognitionModule, FacialRecognitionService, LandmarksFeatureToken, ModelLoaderService, ModelsUrl, MtcnnModel, SsdMobilenetv1Model, TinyFaceDetectorModel, WebcamComponent };
//# sourceMappingURL=akeela-facial-recognition.js.map
